import React, { useEffect, useRef, useState } from 'react';
import './altera-senha.component.scss';
import { enviarAlteracaoDeSenha } from '../../../services/altera-senha';
import { useNavigate } from 'react-router-dom';
import { obterUsuarioSessao, salvarCredenciais } from '../../../services/salva-credenciais';
import { alertService } from '../../../services/alertService';
import { useTranslation } from 'react-i18next';

const AlterarSenhaComponent = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmaNovaSenha, setConfirmaNovaSenha] = useState('');
    const [alterandoSenha, setAlterandoSenha] = useState(false);

    const refSenhaAtual = useRef<HTMLInputElement>(null);
    const refNovaSenha = useRef<HTMLInputElement>(null);
    const refConfirmarNovaSenha = useRef<HTMLInputElement>(null);

    function handleChanged(evt: any) {
        const { name, value } = evt.target;
        if (name === 'txtSenhaAtual') setSenhaAtual(value);
        if (name === 'txtNovaSenha') setNovaSenha(value);
        if (name === 'txtConfirmarNovaSenha') setConfirmaNovaSenha(value);
    }

    function alterarSenha(): void {

        setAlterandoSenha(true);

        enviarAlteracaoDeSenha(obterUsuarioSessao()!, senhaAtual, novaSenha)
            .then(() => {

                salvarCredenciais(obterUsuarioSessao()!, novaSenha);
                limparCampos();
                setAlterandoSenha(false);

                alertService.sucesso(
                    t("CHANGE_PASSWORD_SUCCESS_TITLE"),
                    t("CHANGE_PASSWORD_SUCCESS_MESSAGE")
                );

                navigate('/painel');
            })
            .catch(() => {
                limparCampos();
                setAlterandoSenha(false);

                alertService.erro(
                    t("CHANGE_PASSWORD_ERROR_TITLE"),
                    t("CHANGE_PASSWORD_ERROR_MESSAGE")
                );
            });
    }

    function limparCampos() {
        setSenhaAtual('');
        setNovaSenha('');
        setConfirmaNovaSenha('');

        if (refSenhaAtual.current && refNovaSenha.current && refConfirmarNovaSenha.current) {
            refSenhaAtual.current.value = '';
            refNovaSenha.current.value = '';
            refConfirmarNovaSenha.current.value = '';
            setTimeout(() => refSenhaAtual.current?.focus(), 1);
        }
    }

    useEffect(() => {
        limparCampos();
    }, []);

    function podeHabilitarBotaoAlterarSenha(): boolean {
        return (
            senhaAtual !== '' &&
            novaSenha !== '' &&
            confirmaNovaSenha !== '' &&
            novaSenha === confirmaNovaSenha &&
            senhaAtual !== novaSenha &&
            !alterandoSenha
        );
    }

    return (
        <div className="altera-senha-component altera-senha-desktop">

            <div className="row ajuste-header-mobile">
                <div className="col-12 text-right">
                    <h6 className="sair" onClick={() => navigate('/painel')}> {t("MY_PURCHASES_CLOSE")}</h6>
                </div>
            </div>

            <div className="row ajuste-header-mobile">
                <div className="col-12 text-center">
                    <h3>{t("CHANGE_PASSWORD_TITLE")}</h3>
                </div>
            </div>

            <div className="row" style={{ marginTop: "2%" }}>
                <div className="col-12">
                    <span>{t("CHANGE_PASSWORD_CURRENT_LABEL")}</span>
                    <input
                        autoFocus
                        tabIndex={1}
                        ref={refSenhaAtual}
                        onChange={handleChanged}
                        name="txtSenhaAtual"
                        type="password"
                        className="form-control"
                        maxLength={16}
                        placeholder={t("CHANGE_PASSWORD_CURRENT_PLACEHOLDER")}
                        required
                    />
                </div>
            </div>

            <div className="row" style={{ marginTop: "2%" }}>
                <div className="col-12">
                    <span>{t("CHANGE_PASSWORD_NEW_LABEL")}</span>
                    <input
                        tabIndex={2}
                        ref={refNovaSenha}
                        onChange={handleChanged}
                        name="txtNovaSenha"
                        type="password"
                        className="form-control"
                        maxLength={16}
                        placeholder={t("CHANGE_PASSWORD_NEW_PLACEHOLDER")}
                        required
                    />
                </div>
            </div>

            <div className="row" style={{ marginTop: "2%" }}>
                <div className="col-12">
                    <span>{t("CHANGE_PASSWORD_CONFIRM_LABEL")}</span>
                    <input
                        tabIndex={3}
                        ref={refConfirmarNovaSenha}
                        onChange={handleChanged}
                        name="txtConfirmarNovaSenha"
                        type="password"
                        className="form-control"
                        maxLength={16}
                        placeholder={t("CHANGE_PASSWORD_CONFIRM_PLACEHOLDER")}
                        required
                    />
                </div>
            </div>

            <div className="row" style={{ marginTop: "2%" }}>
                <div className="col-lg-4">
                    <button
                        disabled={!podeHabilitarBotaoAlterarSenha()}
                        tabIndex={4}
                        onClick={alterarSenha}
                        className="btn btn-alteracao-senha form-control"
                    >
                        {t("CHANGE_PASSWORD_BUTTON")}
                    </button>
                </div>
            </div>

        </div>
    );
};

export default AlterarSenhaComponent;
